import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

// Create vuex-persist instance
const vuexLocal = new VuexPersistence({
  storage: window.localStorage, // Use localStorage for persistence
  // You can also use sessionStorage: window.sessionStorage
  // Or a custom storage adapter
})

// Create and export the store
export default createStore({
  state: {
    currentUser: null,
    currentFacility: null,
  },
  mutations: {
    SET_CURRENT_USER(state, user) {
      state.currentUser = user
    },
    SET_CURRENT_FACILITY(state, facility) {
      state.currentFacility = facility
    },
    CLEAR_CURRENT_FACILITY(state) {
      state.currentFacility = null
    },
  },
  actions: {
    setCurrentUser({ commit }, user) {
      commit('SET_CURRENT_USER', user)
    },
    setCurrentFacility({ commit }, facility) {
      commit('SET_CURRENT_FACILITY', facility)
    },
    clearCurrentFacility({ commit }) {
      commit('CLEAR_CURRENT_FACILITY')
    },
  },
  getters: {
    // Your getters here
    // Example:
    // isAuthenticated: (state) => !!state.user,
    currentFacility: (state) => state.currentFacility,
    facilityId: (state) => state.currentFacility?.facility_id || null,
    facilityName: (state) => state.currentFacility?.facility_name || null,
  },
  modules: {
    // Your modules here (if you want to split the store into modules)
  },
  plugins: [vuexLocal.plugin] // Add the persistence plugin
})

